import "./primaryContactDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import PrimaryContactDetailsViewComponent from "./primary-contact-details-view/primaryContactDetailsViewComponent";
import PrimaryContactDetailsEditComponent from "./primary-contact-details-edit/primaryContactDetailsEditComponent";

interface PrimaryContactDetailsViewEditComponentProps {
    facilityDetails: any;
    onUpdatePrimaryContactDetails: Function;
    onModeChange:Function;
    canEdit: boolean;
}

const PrimaryContactDetailsViewEditComponent = (props: PrimaryContactDetailsViewEditComponentProps) => {
    const {facilityDetails, onUpdatePrimaryContactDetails,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [facilityPrimaryContactDetails, setFacilityPrimaryContactDetails] = useState<any>(undefined);

    const handlePrimaryContactDetailsUpdate = useCallback((updatedPrimaryContactDetails: any) => {
        onUpdatePrimaryContactDetails(updatedPrimaryContactDetails);
        setMode("view");
    }, [onUpdatePrimaryContactDetails]);

    const handlePrimaryContactDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (facilityDetails) {
            setFacilityPrimaryContactDetails(facilityDetails);
        }
    }, [facilityDetails]);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange]);

    return (
        <div className={'primary-contact-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <PrimaryContactDetailsViewComponent
                    facilityPrimaryContactDetails={facilityPrimaryContactDetails?.primaryContactDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" &&
                <PrimaryContactDetailsEditComponent facilityDetails={facilityPrimaryContactDetails}
                                                    facilityId={facilityDetails.id}
                                                    onUpdateComplete={handlePrimaryContactDetailsUpdate}
                                                    onEditCancel={handlePrimaryContactDetailsEditCancel}
                />
            }
        </div>
    );

};

export default PrimaryContactDetailsViewEditComponent;
